import * as React from 'react';
export var RenderHtml = function (props) {
    var html = { __html: props.html };
    return React.createElement("span", { dangerouslySetInnerHTML: html, className: props.className });
};
//# sourceMappingURL=render-html.comp.js.map